export class StockService {
    constructor(config, queryConfig) {
        this.latestQuery = '';
        this.config = config;
        this.queryConfig = queryConfig;
        this.client = config.client;
    }
    setFilter(key, values, isRange = false) {
        if (this.queryConfig.options.filters.all) {
            const existingFilter = this.getFilter(key);
            const copy = [...this.queryConfig.options.filters.all];
            if (existingFilter === null || existingFilter === void 0 ? void 0 : existingFilter.filter) {
                if (isRange) {
                    const rangeObject = Object.assign({}, values);
                    const toRemove = Object.keys(rangeObject).filter((key) => rangeObject[key] === 0);
                    toRemove.forEach((prop) => {
                        delete rangeObject[prop];
                    });
                    if (!Object.keys(rangeObject).length) {
                        copy.splice(existingFilter.index, 1);
                    }
                    else {
                        copy.splice(existingFilter.index, 1, { [key]: rangeObject });
                    }
                }
                else {
                    if (existingFilter.filter[key]) {
                        existingFilter.filter[key] = values;
                    }
                }
            }
            else {
                if (isRange) {
                    if (values.from !== 0 || values.to !== 0) {
                        copy.push({ [key]: values });
                    }
                }
                else {
                    copy.push({ [key]: values });
                }
            }
            this.queryConfig.options.filters.all = copy;
        }
    }
    getFilter(key) {
        if (this.queryConfig.options.filters.all) {
            const filter = this.queryConfig.options.filters.all.find((_filter) => {
                /** @ts-ignore */
                const _key = Object.keys(_filter)[0];
                return key === _key;
            });
            const index = this.queryConfig.options.filters.all.findIndex((__filter) => {
                /** @ts-ignore */
                const _key = Object.keys(__filter)[0];
                return key === _key;
            });
            if (filter) {
                return { filter: filter, index: index };
            }
        }
        return null;
    }
    get(userQuery, type, value, rangeSelector, sorting) {
        return new Promise((resolve, reject) => {
            var _a, _b, _c, _d;
            // Inject user Query in query config
            this.queryConfig.query = userQuery;
            if (type && typeof value === 'number' && rangeSelector) {
                // Check op typeof want 0 is geen value
                let filterActive = false;
                (_a = this.queryConfig.options.filters.all) === null || _a === void 0 ? void 0 : _a.forEach((obj, index) => {
                    var _a;
                    if (Object.keys(obj).includes(type)) {
                        // Haal de bestaande waarde op
                        let existingValue = obj[type];
                        if (value === 0) {
                            delete existingValue[rangeSelector]; // Verwijder 'rangeSelector'
                        }
                        else {
                            existingValue = Object.assign(Object.assign({}, existingValue), { [rangeSelector]: value }); // Voeg of vervang eigenschappen van 'value' toe aan 'existingValue'
                        }
                        obj[type] = existingValue;
                        filterActive = true;
                        if (Object.keys(existingValue).length === 0) {
                            (_a = this.queryConfig.options.filters.all) === null || _a === void 0 ? void 0 : _a.splice(index, 1); // Verwijder het object uit de array
                        }
                    }
                });
                if (!filterActive) {
                    (_b = this.queryConfig.options.filters.all) === null || _b === void 0 ? void 0 : _b.push({ [type]: { [rangeSelector]: value } });
                }
            }
            else if (type && value) {
                let filterActive = false;
                (_c = this.queryConfig.options.filters.all) === null || _c === void 0 ? void 0 : _c.forEach((obj) => {
                    if (Object.keys(obj).includes(type)) {
                        // Haal de bestaande waarde op
                        let existingValue = obj[type];
                        // Controleer of de bestaande waarde al een array is
                        if (Array.isArray(existingValue)) {
                            // Controleer of de waarde al in de array zit
                            if (existingValue.includes(value)) {
                                // Verwijder de waarde uit de array
                                obj[type] = existingValue.filter((v) => v !== value);
                                // Als de array leeg is, verwijder het filter
                                if (obj[type].length === 0) {
                                    delete obj[type];
                                }
                            }
                            else {
                                // Voeg de nieuwe waarde toe aan de bestaande array
                                obj[type] = [...existingValue, value];
                            }
                        }
                        else if (existingValue === value) {
                            // Als er maar één waarde is en die moet worden verwijderd, verwijder het filter
                            delete obj[type];
                        }
                        else {
                            // Maak een nieuwe array met de bestaande waarde en de nieuwe waarde
                            obj[type] = [existingValue, value];
                        }
                        filterActive = true;
                    }
                });
                if (!filterActive) {
                    (_d = this.queryConfig.options.filters.all) === null || _d === void 0 ? void 0 : _d.push({ [type]: value });
                }
            }
            /** filter filters, clearing filters without values */
            if (this.queryConfig.options.filters.all) {
                this.queryConfig.options.filters.all = this.queryConfig.options.filters.all.filter((filter) => {
                    // @ts-ignore
                    const key = Object.keys(filter)[0];
                    // @ts-ignore
                    const values = filter[key];
                    const isArray = typeof values === 'object' ? Array.isArray(values) : false;
                    const type = isArray ? 'array' : typeof values;
                    switch (type) {
                        case 'object':
                            return true;
                        default:
                            return values.length > 0;
                    }
                });
            }
            const query = `${JSON.stringify(this.queryConfig.query)}${JSON.stringify(this.queryConfig.options)}`;
            this.latestQuery = query;
            this.client.search(this.queryConfig.query, this.queryConfig.options).then((resultList) => {
                if (this.latestQuery === query) {
                    // @ts-ignore
                    resolve(resultList);
                }
                reject('prevented old request');
            });
        });
    }
    sort(userQuery, sorting) {
        this.queryConfig.query = userQuery;
        if (this.queryConfig.options.sort) {
            this.queryConfig.options.sort = {};
            const [key, order] = sorting.split(':');
            this.queryConfig.options.sort[key] = order;
        }
        return this.client.search(this.queryConfig.query, this.queryConfig.options).then((resultList) => {
            return resultList;
        });
    }
}
